import { currentUser, isLoggedIn } from '@/service/user'
import { format } from 'date-fns'

export default {
    currentUser () {
        return currentUser()
    },

    isLoggedIn () {
        return isLoggedIn()
    },

    env (key) {
        return process.env[key] || ''
    },

    slugify (val) {
        return val.replace(/[^0-9a-zA-Z]/g, '')
    },

    slugifyUrl(text) {
        return text
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .trim()
            .replace(/\s+/g, '-')
            .replace(/[^\w-]+/g, '')
            .replace(/--+/g, '-')
    },

    getApiBaseUrl () {
        return  this.env('VUE_APP_API_BASE_URL')
    },

    getColors () {
        const colors = {
            '#ef0000': '#770000',
            '#1fbc9c': '#015341',
            '#1ca085': '#014b3b',
            '#2ecc70': '#008136',
            '#27af60': '#006c2d',
            '#3398db': '#004675',
            '#2980b9': '#002945',
            '#a463bf': '#4c016c',
            '#8e43ad': '#490a63',
            '#3d556e': '#00152c',
            '#222f3d': '#0d1a27',
            '#f2c511': '#776005',
            '#e84b3c': '#960d00',
            '#c0382b': '#590800',
            '#f39c19': '#cc810f',
            '#ffffff': '#ffffff'
        }

        return colors
    },

    chunk(array, size) {
        if (!array) return []
        const firstChunk = array.slice(0, size)
        if (!firstChunk.length) {
            return array
        }
        return [firstChunk].concat(this.chunk(array.slice(size, array.length), size))
    },

    hexToRgba (hex) {
        var c;
        if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
            c= hex.substring(1).split('')
            if (c.length== 3) {
                c = [c[0], c[0], c[1], c[1], c[2], c[2]]
            }
            c = '0x'+c.join('')
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+',1)'
        }
        throw new Error('Bad Hex')
    },

    kNumberFormat (num) {
        return Math.abs(num) > 999 ? Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'k' : Math.sign(num)*Math.abs(num)
    },

    convertDateFormat (date) {
        if (new Date(date) instanceof Date && new Date(date) != 'Invalid Date') {
            var convertTime = new Date(date);

            return convertTime.toISOString().replace(/T/, ' ').substring(0, 16);
        }
        return 'Invalid Date'
    },

    numberOnly (event, isPreventDefault = true) {
        let status = true;
        const keyEvent = (event) || window.event;
        const charCode = (keyEvent.which) ? keyEvent.which : keyEvent.keyCode;
        if (this.isCodeNumeric(charCode, event.key)
            || (charCode === 8)
            || (charCode === 46)) {
            status = true;
        } else {
            status = false;
            if (isPreventDefault) {
                keyEvent.preventDefault();
            }
        }

        return status;
    },

    isCodeNumeric(charCode, key) {
        const reg = new RegExp('^[0-9]$');
        return reg.test(key) && (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105);
    },

    toNumberFormat (num) {
        return new Intl.NumberFormat('no-No').format(num)
    },

    objectWithoutProperties(obj, keys) {
        let target = {}
        for (let i in obj) {
            if (keys.indexOf(i) >= 0) continue
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue
            target[i] = obj[i]
        }
        return target
    },

    arrayUnique(array) {
        let a = array.concat()
        for(let i=0; i<a.length; ++i) {
            for(let j=i+1; j<a.length; ++j) {
                if(a[i] === a[j])
                    a.splice(j--, 1)
            }
        }
        return a
    },

    move(arr, old_index, new_index) {
        while (old_index < 0) {
            old_index += arr.length
        }
        while (new_index < 0) {
            new_index += arr.length
        }
        if (new_index >= arr.length) {
            var k = new_index - arr.length
            while ((k--) + 1) {
                arr.push(undefined)
            }
        }
        arr.splice(new_index, 0, arr.splice(old_index, 1)[0])
        return arr
    },

    numpad (n) {
        return (n < 10 ? '0' : '') + n
    },

    dateFormat(date) {
        return format(new Date(parseFloat(date)), 'yyyy-MM-dd HH:mm:ii')
    },

    getLanguageNameByCode(lang) {

        lang = lang.toLowerCase()
        const langNameInEnglish = new Intl.DisplayNames(['en'], { type: 'language' })

        if (lang === 'dk') {
            lang = 'da'
        }

        if (lang === 'se') {
            lang = 'sv'
        }

        return langNameInEnglish.of(lang)
    }
}
